import { render, staticRenderFns } from "./SingleReserves.vue?vue&type=template&id=0e25e22e&scoped=true&"
import script from "./SingleReserves.vue?vue&type=script&lang=js&"
export * from "./SingleReserves.vue?vue&type=script&lang=js&"
import style0 from "./SingleReserves.vue?vue&type=style&index=0&lang=css&"
import style1 from "./SingleReserves.vue?vue&type=style&index=1&id=0e25e22e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e25e22e",
  null
  
)

component.options.__file = "SingleReserves.vue"
export default component.exports